export type KeyCode =
    'Affirmative' |
    'Escape' |
    'Digit1' |
    'Digit2' |
    'Digit3' |
    'Digit4' |
    'Digit5' |
    'Digit6' |
    'Digit7' |
    'Digit8' |
    'Digit9' |
    'Digit0' |
    'Minus' |
    'Equal' |
    'Backspace' |
    'Tab' |
    'KeyQ' |
    'KeyW' |
    'KeyE' |
    'KeyR' |
    'KeyT' |
    'KeyY' |
    'KeyU' |
    'KeyI' |
    'KeyO' |
    'KeyP' |
    'BracketLeft' |
    'BracketRight' |
    'Enter' |
    'ControlLeft' |
    'KeyA' |
    'KeyS' |
    'KeyD' |
    'KeyF' |
    'KeyG' |
    'KeyH' |
    'KeyJ' |
    'KeyK' |
    'KeyL' |
    'Semicolon' |
    'Quote' |
    'Backquote' |
    'ShiftLeft' |
    'Backslash' |
    'KeyZ' |
    'KeyX' |
    'KeyC' |
    'KeyV' |
    'KeyB' |
    'KeyN' |
    'KeyM' |
    'Comma' |
    'Period' |
    'Slash' |
    'ShiftRight' |
    'NumpadMultiply' |
    'AltLeft' |
    'Space' |
    'CapsLock' |
    'F1' |
    'F2' |
    'F3' |
    'F4' |
    'F5' |
    'F6' |
    'F7' |
    'F8' |
    'F9' |
    'F10' |
    'Pause' |
    'ScrollLock' |
    'Numpad7' |
    'Numpad8' |
    'Numpad9' |
    'NumpadSubtract' |
    'Numpad4' |
    'Numpad5' |
    'Numpad6' |
    'NumpadAdd' |
    'Numpad1' |
    'Numpad2' |
    'Numpad3' |
    'Numpad0' |
    'NumpadDecimal' |
    'IntlBackslash' |
    'F11' |
    'F12' |
    'NumpadEqual' |
    'F13' |
    'F14' |
    'F15' |
    'F16' |
    'F17' |
    'F18' |
    'F19' |
    'F20' |
    'F21' |
    'F22' |
    'F23' |
    'KanaMode' |
    'Lang2' |
    'Lang1' |
    'IntlRo' |
    'F24' |
    'Lang4' |
    'Lang3' |
    'Convert' |
    'NonConvert' |
    'IntlYen' |
    'NumpadComma' |
    'Undo' |
    'Paste' |
    'MediaTrackPrevious' |
    'Cut' |
    'Copy' |
    'MediaTrackNext' |
    'NumpadEnter' |
    'ControlRight' |
    'AudioVolumeMute' |
    'LaunchApp2' |
    'MediaPlayPause' |
    'MediaStop' |
    'Eject' |
    'AudioVolumeDown' |
    'AudioVolumeUp' |
    'BrowserHome' |
    'NumpadDivide' |
    'PrintScreen' |
    'AltRight' |
    'Help' |
    'NumLock' |
    'Home' |
    'ArrowUp' |
    'PageUp' |
    'ArrowLeft' |
    'ArrowRight' |
    'End' |
    'ArrowDown' |
    'PageDown' |
    'Insert' |
    'Delete' |
    'MetaLeft' |
    'MetaRight' |
    'ContextMenu' |
    'Power' |
    'Sleep' |
    'WakeUp' |
    'BrowserSearch' |
    'BrowserFavorites' |
    'BrowserRefresh' |
    'BrowserStop' |
    'BrowserForward' |
    'BrowserBack' |
    'LaunchApp1' |
    'LaunchMail' |
    'MediaSelect';

export const ALL_DIGITS = [
    'Digit0',
    'Digit1',
    'Digit2',
    'Digit3',
    'Digit4',
    'Digit5',
    'Digit6',
    'Digit7',
    'Digit8',
    'Digit9'
];
export const ALL_NUMPAD = [
    'Numpad0',
    'Numpad1',
    'Numpad2',
    'Numpad3',
    'Numpad4',
    'Numpad5',
    'Numpad6',
    'Numpad7',
    'Numpad8',
    'Numpad9'
];

export const HumanizedKeyCode = {
    'Affirmative': 'Enter',
    'Escape': 'Escape',
    'Digit1': '1',
    'Digit2': '2',
    'Digit3': '3',
    'Digit4': '4',
    'Digit5': '5',
    'Digit6': '6',
    'Digit7': '7',
    'Digit8': '8',
    'Digit9': '9',
    'Digit0': '0',
    'Minus': '-',
    'Equal': '=',
    'Backspace': '⌫',
    'Tab': 'Tab',
    'KeyQ': 'Q',
    'KeyW': 'W',
    'KeyE': 'E',
    'KeyR': 'R',
    'KeyT': 'T',
    'KeyY': 'Y',
    'KeyU': 'U',
    'KeyI': 'I',
    'KeyO': 'O',
    'KeyP': 'P',
    'BracketLeft': '[',
    'BracketRight': ']',
    'Enter': 'Enter',
    'ControlLeft': 'LCtrl',
    'KeyA': 'A',
    'KeyS': 'S',
    'KeyD': 'D',
    'KeyF': 'F',
    'KeyG': 'G',
    'KeyH': 'H',
    'KeyJ': 'J',
    'KeyK': 'K',
    'KeyL': 'L',
    'Semicolon': ';',
    'Quote': "'",
    'Backquote': '`',
    'ShiftLeft': 'LShift',
    'Backslash': '\\',
    'KeyZ': 'Z',
    'KeyX': 'X',
    'KeyC': 'C',
    'KeyV': 'V',
    'KeyB': 'B',
    'KeyN': 'N',
    'KeyM': 'M',
    'Comma': ',',
    'Period': '.',
    'Slash': '/',
    'ShiftRight': 'RShift',
    'NumpadMultiply': 'Num*',
    'AltLeft': 'LAlt',
    'Space': 'Space',
    'CapsLock': 'CapsLock',
    'F1': 'F1',
    'F2': 'F2',
    'F3': 'F3',
    'F4': 'F4',
    'F5': 'F5',
    'F6': 'F6',
    'F7': 'F7',
    'F8': 'F8',
    'F9': 'F9',
    'F10': 'F10',
    'Pause': 'Pause',
    'ScrollLock': 'ScrollLock',
    'Numpad7': 'Num7',
    'Numpad8': 'Num8',
    'Numpad9': 'Num9',
    'NumpadSubtract': 'Num-',
    'Numpad4': 'Num4',
    'Numpad5': 'Num5',
    'Numpad6': 'Num6',
    'NumpadAdd': 'Num+',
    'Numpad1': 'Num1',
    'Numpad2': 'Num2',
    'Numpad3': 'Num3',
    'Numpad0': 'Num0',
    'NumpadDecimal': 'Num.',
    'IntlBackslash': '',
    'F11': 'F11',
    'F12': 'F12',
    'NumpadEqual': 'Num=',
    'F13': 'F13',
    'F14': 'F14',
    'F15': 'F15',
    'F16': 'F16',
    'F17': 'F17',
    'F18': 'F18',
    'F19': 'F19',
    'F20': 'F20',
    'F21': 'F21',
    'F22': 'F22',
    'F23': 'F23',
    'KanaMode': 'KanaMode',
    'Lang2': 'Lang2',
    'Lang1': 'Lang1',
    'IntlRo': 'IntlRo',
    'F24': 'F24',
    'Lang4': 'Lang4',
    'Lang3': 'Lang3',
    'Convert': 'Convert',
    'NonConvert': 'NonConvert',
    'IntlYen': 'IntlYen',
    'NumpadComma': 'Num,',
    'Undo': 'Undo',
    'Paste': 'Paste',
    'MediaTrackPrevious': 'Previous',
    'Cut': 'Cut',
    'Copy': 'Copy',
    'MediaTrackNext': 'Next',
    'NumpadEnter': 'NumEnter',
    'ControlRight': 'RCtrl',
    'AudioVolumeMute': 'Mute',
    'LaunchApp2': 'LaunchApp2',
    'MediaPlayPause': 'Play/Pause',
    'MediaStop': 'Stop',
    'Eject': 'Eject',
    'AudioVolumeDown': 'VolumeDown',
    'AudioVolumeUp': 'VolumeUp',
    'BrowserHome': 'Browser Home',
    'NumpadDivide': 'Num/',
    'PrintScreen': 'PrintScreen',
    'AltRight': 'RAlt',
    'Help': 'Help',
    'NumLock': 'NumLock',
    'Home': 'Home',
    'ArrowUp': '↑',
    'PageUp': 'PageUp',
    'ArrowLeft': '←',
    'ArrowRight': '→',
    'End': 'End',
    'ArrowDown': '↓',
    'PageDown': 'PageDown',
    'Insert': 'Insert',
    'Delete': 'Delete',
    'MetaLeft': 'MetaLeft',
    'MetaRight': 'MetaRight',
    'ContextMenu': 'ContextMenu',
    'Power': 'Power',
    'Sleep': 'Sleep',
    'WakeUp': 'WakeUp',
    'BrowserSearch': 'Search',
    'BrowserFavorites': 'Favorites',
    'BrowserRefresh': 'Refresh',
    'BrowserStop': 'Stop',
    'BrowserForward': 'Forward',
    'BrowserBack': 'Back',
    'LaunchApp1': 'LaunchApp1',
    'LaunchMail': 'LaunchMail',
    'MediaSelect': 'MediaSelect'
};